import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsPencil } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import Card from '#globalComponents/Card/Card';

import CustomFieldsSection from '../../common/CustomFieldsSection/CustomFieldsSection';

const CompanyInfoCard = ({ company, companyFieldDefs, onSave }) => {
	const [editing, setEditing] = useState(false);
	const [draft, setDraft] = useState({});

	const startEdit = () => {
		const d = { _customFields: { ...(company?.customFields ?? {}) } };
		for (const def of companyFieldDefs) {
			if (def.isDefault) d[def.fieldKey] = company?.[def.fieldKey] ?? '';
		}
		setDraft(d);
		setEditing(true);
	};

	const handleSave = () => {
		setEditing(false);
		const patch = {};
		for (const def of companyFieldDefs) {
			if (!def.isDefault) continue;
			if (draft[def.fieldKey] !== (company?.[def.fieldKey] ?? '')) {
				patch[def.fieldKey] = draft[def.fieldKey] || null;
			}
		}
		const origCf = company?.customFields ?? {};
		const draftCf = draft._customFields ?? {};
		if (JSON.stringify(origCf) !== JSON.stringify(draftCf)) {
			patch.customFields = draftCf;
		}
		if (Object.keys(patch).length > 0) onSave(patch);
	};

	const cancelEdit = () => setEditing(false);

	return (
		<Card
			className={`overflow-hidden p-0 transition-colors ${editing ? 'border-primary-300 ring-2 ring-primary-300' : ''}`}
		>
			<div
				className={`px-4 py-2.5 border-b flex items-center justify-between transition-colors ${
					editing ? 'bg-primary-100 border-primary-300' : 'bg-bgBase-300 border-bgBase-500'
				}`}
			>
				<h4 className="text-xs-head text-text">Unternehmen</h4>
				{!editing ? (
					<button
						type="button"
						onClick={startEdit}
						className="inline-flex items-center gap-1 text-[11px] text-bgBase-800 hover:text-text transition-colors"
					>
						<BsPencil className="w-2.5 h-2.5" /> Bearbeiten
					</button>
				) : (
					<div className="flex gap-1">
						<Button type="button" variant="outline" size="sm" onClick={cancelEdit}>
							Abbrechen
						</Button>
						<Button type="button" variant="solid" size="sm" onClick={handleSave}>
							Speichern
						</Button>
					</div>
				)}
			</div>
			<div className="p-3 space-y-2">
				{editing ? (
					<CustomFieldsSection
						entityType="company"
						entity={{ ...company, ...draft }}
						values={draft._customFields ?? company.customFields ?? {}}
						inline
						showLabel={false}
						onChangeEntity={(fieldKey, value) => setDraft((d) => ({ ...d, [fieldKey]: value }))}
						onChange={(fieldId, value) =>
							setDraft((d) => ({ ...d, _customFields: { ...(d._customFields ?? {}), [fieldId]: value } }))
						}
					/>
				) : (
					<CustomFieldsSection
						entityType="company"
						entity={company}
						values={company.customFields ?? {}}
						onSave={(cf) => onSave({ customFields: cf })}
						onSaveEntity={(fieldKey, value) => onSave({ [fieldKey]: value })}
						readOnly
						showLabel={false}
					/>
				)}
			</div>
		</Card>
	);
};

CompanyInfoCard.propTypes = {
	company: PropTypes.object.isRequired,
	companyFieldDefs: PropTypes.array.isRequired,
	onSave: PropTypes.func.isRequired,
};

export default CompanyInfoCard;
